export default __webpack_public_path__ + "c2885de6b8e81f8fd0a83f7e7c270421.svg";